
import React from 'react';

export const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6 authority-brand-font-large">ABOUT BUSINESS DEVELOPMENT AUTHORITY INC.</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A comprehensive management corporation driving innovation and growth across multiple industries through strategic leadership and expert guidance.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Mission</h3>
            <p className="text-gray-600 mb-6">
              Business Development Authority Inc. serves as the parent company for a diverse portfolio of specialized authorities, each leading their respective industries through innovation, expertise, and strategic partnerships.
            </p>
            <p className="text-gray-600 mb-6">
              We focus on corporate governance, client acquisition, and strategic partnerships to drive scalable revenue growth across all our subsidiary companies and client organizations.
            </p>
            <div className="bg-white p-6 rounded-lg shadow-sm border">
              <h4 className="text-lg font-semibold text-gray-900 mb-3">Corporate Headquarters</h4>
              <div className="flex items-start space-x-3 mb-4">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-map-pin-line text-blue-600"></i>
                </div>
                <div>
                  <p className="text-gray-600">
                    725 E Road 2 N Unit 1494<br />
                    Chino Valley, AZ 86323
                  </p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-5 h-5 flex items-center justify-center mt-1">
                  <i className="ri-phone-line text-blue-600"></i>
                </div>
                <div>
                  <a href="tel:928-963-2760" className="text-gray-600 hover:text-blue-600">
                    928 963 2760
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/3527a31bb2bd928f7430fca3c3c6d76c.jpg"
              alt="Business Development Authority corporate headquarters"
              className="w-full h-80 object-cover object-top rounded-lg shadow-lg"
            />
          </div>
        </div>

        <div className="mb-16">
          <h3 className="text-3xl font-bold text-gray-900 text-center mb-12">Our Authority Portfolio</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-lg mb-4">
                <i className="ri-plane-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Travel Authority</h4>
              <p className="text-gray-600 mb-4">
                Comprehensive travel solutions and industry expertise for corporate and leisure travel management.
              </p>
              <a 
                href="#" 
                className="text-blue-600 hover:text-blue-700 font-medium transition-colors cursor-pointer"
              >
                Learn More →
              </a>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-green-100 rounded-lg mb-4">
                <i className="ri-robot-line text-2xl text-green-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">AI Consulting Authority</h4>
              <p className="text-gray-600 mb-4">
                Strategic AI implementation and consulting services to transform businesses through artificial intelligence.
              </p>
              <a 
                href="https://aiconsultingauthority.net/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-700 font-medium transition-colors cursor-pointer"
              >
                Visit Website →
              </a>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-purple-100 rounded-lg mb-4">
                <i className="ri-book-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">AI Book Authority</h4>
              <p className="text-gray-600 mb-4">
                Publishing and educational resources focused on artificial intelligence and emerging technologies.
              </p>
              <a 
                href="https://aibookauthority.com/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-purple-600 hover:text-purple-700 font-medium transition-colors cursor-pointer"
              >
                Visit Website →
              </a>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg mb-4">
                <i className="ri-building-line text-2xl text-orange-600"></i>
              </div>
              <h4 className="text-xl font-semibold text-gray-900 mb-3">Real Estate Development Authority</h4>
              <p className="text-gray-600 mb-4">
                Strategic real estate development and investment solutions for commercial and residential projects.
              </p>
              <a 
                href="https://jefferylong.exprealty.com/" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-600 hover:text-orange-700 font-medium transition-colors cursor-pointer"
              >
                Visit Portfolio →
              </a>
            </div>
          </div>
        </div>

        <div className="bg-white p-8 rounded-lg shadow-lg">
          <div className="text-center">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Leadership Authority</h3>
            <p className="text-gray-600 mb-6">
              Led by recognized industry authority Jeffery Long, our organization brings decades of expertise in business development, strategic partnerships, and corporate governance.
            </p>
            <a 
              href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5?ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true&ccs_id=043cae77-eaa8-440d-8b65-2edc56fe7c65" 
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center mr-2">
                <i className="ri-external-link-line"></i>
              </div>
              View Authority Page
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};